import script from "./CloudGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloudGuide.vue?vue&type=script&setup=true&lang=ts"

import "./CloudGuide.vue?vue&type=style&index=0&id=5512ae1a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5512ae1a"]])

export default __exports__